import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Prerendered snapshots carry their page JSON-LD; usePageMeta re-injects it on mount.
document.querySelectorAll('script[data-page-jsonld]').forEach((s) => s.remove());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

requestAnimationFrame(() => {
  document.documentElement.classList.remove("pr-stale", "pr-gate-ok", "pr-consent-set");
});
